import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ReactComponent as DashboardIcon } from 'images/v2/icons/svg/fill/svg/dashboard.svg';
import { ReactComponent as SearchIcon } from 'images/v2/icons/svg/fill/svg/search.svg';

type TProps = {
  anyExist: boolean;
  isCopyGroupsView?: boolean;
  listView?: boolean;
};

const NoEPDs = ({ anyExist, isCopyGroupsView, listView }: TProps) => {
  const { t } = useTranslation();
  const translationKey = isCopyGroupsView ? 'epdDashboard.companyHasNoCopyGroups' : 'epdDashboard.companyHasNoEpds';

  return (
    <NoEPDsContainer $listView={listView}>
      <Content>
        {anyExist ? <SearchIconStyled /> : <DashboardIconStyled />}
        <TextBlock>
          <Title>{anyExist ? t(`${translationKey}.header_1`) : t(`${translationKey}.header_2`)}</Title>
          <Description>{anyExist ? t(`${translationKey}.info_1`) : t(`${translationKey}.info_2`)}</Description>
        </TextBlock>
      </Content>
    </NoEPDsContainer>
  );
};

const NoEPDsContainer = styled.div<{ $listView?: boolean }>`
  width: 100%;
  min-width: 814px;
  height: 410px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.colors.primaryWhite};
  border-radius: 4px;
  box-shadow: ${(props) => (props.$listView ? 'none' : '0px 4px 6px rgba(0, 0, 0, 0.04)')};
  box-sizing: border-box;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
`;

const DashboardIconStyled = styled(DashboardIcon)`
  width: 139.33px;
  height: 139.33px;
`;

const SearchIconStyled = styled(SearchIcon)`
  width: 158px;
  height: 158px;
`;

const TextBlock = styled.div`
  margin-left: 16px;
`;

const Title = styled.div`
  font-family: 'Inter';
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.primaryBlack};
`;

const Description = styled.div`
  margin-top: 12px;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.primaryBlack50};
`;

export default NoEPDs;
